import Step from "./Step";

type Props = {
  steps: string[];
  stepperState: number;
  handleStepClicked?: $TSFixMeFunction;
  disableBackStepAt?: {
    stepIndex?: number;
    disabled?: number[];
  }[];
};

function Stepper({
  steps,
  stepperState,
  disableBackStepAt = [],
  handleStepClicked,
}: Props) {
  const getStepClassName = (stepIndex: $TSFixMe) => {
    if (stepIndex < stepperState) return " is-prev";
    if (stepIndex === stepperState) return " is-current";
    return " is-next";
  };

  function handleClicked(stepIndex: $TSFixMe) {
    if (stepIndex < stepperState) {
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      handleStepClicked(stepIndex);
    }
  }

  return (
    <div className="c-process-wrapper">
      <ol className="c-process">
        {steps.map((step, index) => {
          const stepClassName = getStepClassName(index);
          const stepsToDisable = disableBackStepAt.find(
            ({ stepIndex }) => stepIndex === stepperState,
          )?.disabled;

          return (
            <Step
              key={step}
              // @ts-expect-error TS(2322) FIXME: Type '(() => void) | null' is not assignable to ty... Remove this comment to see the full error message
              handleClicked={
                !stepsToDisable?.includes(index)
                  ? () => handleClicked(index)
                  : null
              }
              stepClassName={stepClassName}
              step={step}
            />
          );
        })}
      </ol>
    </div>
  );
}

export default Stepper;
